import { render, staticRenderFns } from "./EditCaptureProfile.vue?vue&type=template&id=676002a2&scoped=true&"
import script from "./EditCaptureProfile.vue?vue&type=script&lang=js&"
export * from "./EditCaptureProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditCaptureProfile.vue?vue&type=style&index=0&id=676002a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676002a2",
  null
  
)

export default component.exports